import { Board, Partner, Society, User } from 'types';
import { NewBoardData } from './saveBoard';

type ParseExistingToNewBoardProps = {
  newBoardName: string;
  newBoardDate: string;
  existingBoard: Board;
  actualSociety: Society;
  partners: Partner[];
  user: User;
};

export const parseExistingToNewBoard = ({
  newBoardName,
  newBoardDate,
  existingBoard,
  actualSociety,
  partners,
  user,
}: ParseExistingToNewBoardProps): NewBoardData => {
  const {
    attendanceType,
    place,
    announcement,
    onlineAccess,
    votePeriod,
    boardType,
    digitalVoting,
    orders,
    president,
    secretary,
    delegationType,
    announcementTemplate,
    actTemplate,
    actCertificateTemplate,
  } = existingBoard;

  const newBoard = {
    name: newBoardName,
    date: new Date(newBoardDate),
    user,
    files: [],
    society: actualSociety,
    partners,
    attendanceType,
    place,
    announcement,
    onlineAccess,
    votePeriod,
    boardType,
    digitalVoting,
    orders,
    president,
    secretary,
    delegationType,
    announcementTemplate,
    actTemplate,
    actCertificateTemplate,
    selectedDelegation: 2,
    selectedPartners: [],
    selectedRepresentants: [],
  };

  return newBoard;
};
